import styled from 'styled-components';

export const SlideMobileOrderModalAssetBoxStyled = styled.div`
    background-color: var(--color-button-secondary-default);
    padding: 4px 8px 4px 4px;
    border-radius: 12px;
    font-size: 14px;
    font-weight: 500;
    align-items: center;

    grid-gap: 1rem;
    gap: 1rem;
    display: flex;
`;
